
import { Card } from "@/components/ui/card"
import type { DashboardStats } from "../types"

interface ExtensionsStatsProps {
  stats: DashboardStats
}

export function ExtensionsStats({ stats }: ExtensionsStatsProps) {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Total Extensions</span>
        <span className="text-2xl font-bold mt-2">{stats.total}</span>
      </Card>
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Published</span>
        <span className="text-2xl font-bold mt-2 text-green-600">{stats.approved}</span>
      </Card>
      <Card className="p-4 flex flex-col justify-between shadow-sm">
        <span className="text-sm font-medium text-muted-foreground">Pending Review</span>
        <div className="flex items-baseline gap-2 mt-2">
          <span className="text-2xl font-bold text-amber-600">{stats.pending}</span>
          {stats.pending > 0 && <span className="text-xs text-amber-600 font-medium animate-pulse">Action required</span>}
        </div>
      </Card>
    </div>
  )
}
